module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/be1537a45eb149bff6a9c4d7b38497e4.svg";